export const ACTION = {
    OPTION: 'OPTION',
    START: 'ENTREE',
    CANCEL: 'ANNULER',
};
